import React from 'react';
import PropTypes from 'prop-types';
import posed, { PoseGroup } from 'react-pose';

import OAuthSignIn from 'pages/sign-in/oauth';
import Container from 'common/container';
import ContentNav from 'common/content-nav';
import Carousel from 'common/carousel';
import LargeScreen from 'common/large-screen';
import SmallScreen from 'common/small-screen';

import RegisterForm from './form';
import TextBlock from './message';

const slides = [
    {
        title: 'Easily Manage Campaigns',
        content:
            'See real time campaign results in one convenient dashboard. No more checking sign-up forms or missing checks.',
    },
    {
        title: 'Turn Fans into Loyal Supporters',
        content:
            'Share your event to give fans and friends a hassle-free way to support your story and campaign.',
    },
    {
        title: 'Get Funded Faster',
        content:
            'Unlock the convenience of credit cards for your supporters and receive one payment when your campaign is complete.',
    },
];

const SlidePose = posed.div({
    initial: { opacity: 0, x: '100%' },
    enter: { opacity: 1, x: '0%' },
    exit: { opacity: 0, x: '-100%' },
});

const RegisterPage = ({ authLinkQs, onRedirect, register, showFlash }) => (
    <Container className="max-w-xxxl sm:py-12 py-24 flex-1 flex flex-col justify-center">
        <div className="w-full max-w-sm mx-auto flex-no-shrink">
            <ContentNav
                links={[
                    { href: `/sign-in${authLinkQs}`, label: 'Sign In' },
                    { href: `/register${authLinkQs}`, label: 'Register' },
                ]}
            />
        </div>
        <div className="sm:pt-12 pt-24 w-full sm:pt-0">
            <div className="lg:flex justify-between items-center -ml-12">
                <LargeScreen>
                    <div className="pl-12 w-1/2">
                        {slides.map(slide => (
                            <TextBlock key={slide.title} {...slide} className="my-12" />
                        ))}
                    </div>
                </LargeScreen>
                <SmallScreen>
                    <Carousel numberOfSlides={slides.length} autoplay>
                        {({ activeSlide }) => {
                            const slide = slides[activeSlide];
                            return (
                                <div className="sm:mb-12 mb-24 pl-12">
                                    <div
                                        className="relative overflow-hidden flex flex-col justify-center items-center"
                                        css={{ minHeight: 200 }}
                                    >
                                        <PoseGroup withParent={false} preEnterPose="initial">
                                            <SlidePose key={slide.title}>
                                                <TextBlock
                                                    className="text-center mx-auto"
                                                    css={{ maxWidth: 480 }}
                                                    {...slide}
                                                />
                                            </SlidePose>
                                        </PoseGroup>
                                    </div>
                                </div>
                            );
                        }}
                    </Carousel>
                </SmallScreen>
                <div className="pl-12 lg:w-1/2 mx-auto lg:mx-0" css={{ maxWidth: 550 }}>
                    <OAuthSignIn className="mb-12 md:px-12" onSuccess={onRedirect} />
                    <div className="sm:p-6 sm:-mx-4 p-12 bg-white shadow-md">
                        <RegisterForm
                            onRegister={onRedirect}
                            register={({ variables }) => register({ ...variables })}
                            showFlash={showFlash}
                        />
                    </div>
                </div>
            </div>
        </div>
    </Container>
);

RegisterPage.propTypes = {
    authLinkQs: PropTypes.string.isRequired,
    onRedirect: PropTypes.func.isRequired,
    register: PropTypes.func.isRequired,
    showFlash: PropTypes.func.isRequired,
};

export default RegisterPage;
